const css = `._7qb3Ma__withinNumericInput input{text-align:right}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"withinNumericInput":"_7qb3Ma__withinNumericInput"};
